import { render } from "./SecuritySettings.vue?vue&type=template&id=ad84c4e6&scoped=true"
import script from "./SecuritySettings.js?vue&type=script&lang=js"
export * from "./SecuritySettings.js?vue&type=script&lang=js"

import "./SecuritySettings.scss?vue&type=style&index=0&id=ad84c4e6&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad84c4e6"]])

export default __exports__